"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitFrequencyManager = void 0;
var util_1 = require("../../util");
var limit_frequency_message_1 = require("./limit-frequency-message");
var message_priority_interface_1 = require("./message-priority.interface");
var user_inout_message_1 = require("./user-inout-message");
var LimitFrequencyManager = /** @class */ (function () {
    function LimitFrequencyManager(dependency) {
        this.dependency = dependency;
        // 当前限频中的消息种类，key为消息类型
        this.limitFrequencyMessageMap = new Map();
        this.limitFrequencyMessageMap.set(user_inout_message_1.USER_INOUT_TYPE, new user_inout_message_1.UserInoutMessage(user_inout_message_1.USER_INOUT_TYPE, message_priority_interface_1.MessagePriority.MIDDLE, this.dependency));
    }
    LimitFrequencyManager.prototype.dispose = function () {
        this.limitFrequencyMessageMap.clear();
        this.reset();
    };
    LimitFrequencyManager.prototype.reset = function () {
        this.memberCount = 0;
    };
    LimitFrequencyManager.prototype.setPriority = function (type, priority) {
        var limitedFrequencyMessage = this.limitFrequencyMessageMap.get(type);
        if (limitedFrequencyMessage) {
            util_1.ConnectionLog.warn("LimitFrequencyManager type:" + type + " is exit.");
        }
        this.limitFrequencyMessageMap.set(type, new limit_frequency_message_1.LimitFrequencyMessage(type, priority, this.dependency));
    };
    LimitFrequencyManager.prototype.handleMessage = function (message) {
        var _this = this;
        this.updateMemberCount(message);
        this.limitFrequencyMessageMap.forEach(function (value) {
            var type = message.head.type;
            if (value.shouldLimit(type)) {
                value === null || value === void 0 ? void 0 : value.handleMessage(message, _this.getLimitFrequencyLevel(), _this.memberCount);
            }
        });
    };
    LimitFrequencyManager.prototype.updateMemberCount = function (message) {
        var _a, _b, _c, _d, _e;
        var types = [
            "USER_NEWINFO" /* USER_NEWINFO */,
            "USER_NEWINFOS" /* USER_NEWINFOS */,
            "USER_LEAVE" /* USER_LEAVE */,
            "USER_LEAVES" /* USER_LEAVES */,
        ];
        if (!types.includes(message.head.type)) {
            return;
        }
        var memberCount = (_e = (_c = (_b = (_a = message.body) === null || _a === void 0 ? void 0 : _a.notice) === null || _b === void 0 ? void 0 : _b.mem_count) !== null && _c !== void 0 ? _c : (_d = message.body) === null || _d === void 0 ? void 0 : _d.mem_count) !== null && _e !== void 0 ? _e : 0;
        this.memberCount = memberCount;
    };
    LimitFrequencyManager.prototype.getLimitFrequencyLevel = function () {
        if (this.memberCount <= message_priority_interface_1.MIN_THRESHOLD) {
            return message_priority_interface_1.LimitFrequencyLevel.LOW;
        }
        if (this.memberCount <= message_priority_interface_1.MIDDLE_THRESHOLD) {
            return message_priority_interface_1.LimitFrequencyLevel.MIDDLE;
        }
        if (this.memberCount <= message_priority_interface_1.MAX_THRESHOLD) {
            return message_priority_interface_1.LimitFrequencyLevel.HIGH;
        }
        return message_priority_interface_1.LimitFrequencyLevel.HIGHEST;
    };
    return LimitFrequencyManager;
}());
exports.LimitFrequencyManager = LimitFrequencyManager;
